
function mobileShowHideToggle(event){
    function getNearestParentWithClass(className, element){
        if(!element.parentElement){
            return;
        }
        if(element.parentElement.classList.contains(className))
        {
            return element.parentElement;
        }
        return getNearestParentWithClass(className, element.parentElement);
    }
    function doMoreLessAction(parent, action){
        for(var Index =0; Index < parent.children.length; Index++){
            var child = parent.children[Index];
            if(child.classList.contains("show_more_container")){
                console.log("Found nested show_more_container, returning");
                continue;
            }
            if(child.classList.contains("show_more_content") || child.classList.contains("mobile_show_more_content")){
                action(child);
                continue;
            }
            doMoreLessAction(child, action);
        }
    }

    
    var thing = getNearestParentWithClass("show_more_container", event.currentTarget);
    function showLessAction(element){
        element.style.height = '';
        element.style.transition = "";
        element.style.paddingTop = '';
        element.style.paddingBottom = '';
        element.style.marginTop = '';
        element.style.marginBottom = '';
        if(element.transitionTimer){
            clearTimeout(element.transitionTimer);
            element.transitionTimer = 0;
        }
    }

    function showMoreAction(element){
        if(element.transitionTimer){
            clearTimeout(element.transitionTimer);
            element.transitionTimer = 0;
        }

        var Height = element.clientHeight;
        console.log("Show More Height:", Height);
        element.style.transition = "none";
        element.style.paddingTop = '0px';
        element.style.paddingBottom = '0px';
        element.style.marginTop = '0px';
        element.style.marginBottom = '0px';
        element.style.height = '0px';
        console.log(element.style);
        setTimeout(function(){ 
            element.style.transition = "";
            element.style.height = Height+"px"; 
            element.style.paddingTop = '';
            element.style.paddingBottom = '';
            element.style.marginTop = '';
            element.style.marginBottom = '';
            console.log(element.style);
        });
        //NOTE(Christof): this matches the timing for the CSS transition, so updates need to be synched (css rule: .show_more_content, .mobile_show_more_content)
        element.transitionTimer = setTimeout(function(){ element.style.height = ''; }, 0.5* 1000);
    }


    thing.classList.toggle("showing_more")
    doMoreLessAction(thing, thing.classList.contains("showing_more") ? showMoreAction : showLessAction);
    if( ! thing.classList.contains("showing_more") )
    {
        event.currentTarget.scrollIntoView({block: 'center', behavior:'smooth'});
    }
    
}